module.exports = __webpack_public_path__ + "static/me-5d88e19060a2e98f8f0bed3ea0c3a283.png";